/**
 * Coalesces render requests into at most one draw per animation frame with
 * per-layer dirty flags. Pointer moves mark layers dirty; the browser paints
 * once per frame.
 * @param {{ drawLayers: (dirtyLayers: { overlay: boolean, static: boolean }) => void }} params
 * @returns {{ dispose: Function, request: (layer: "static" | "overlay" | "both") => void }}
 */
export const createRenderScheduler = ({ drawLayers }) => {
  const dirtyLayers = { overlay: false, static: false };
  let frameId = null;
  let isDisposed = false;

  const flush = () => {
    frameId = null;
    if (isDisposed) return;
    const layersToDraw = { ...dirtyLayers };
    dirtyLayers.static = false;
    dirtyLayers.overlay = false;
    drawLayers(layersToDraw);
  };

  const request = (layer) => {
    if (layer === "static" || layer === "both") dirtyLayers.static = true;
    if (layer === "overlay" || layer === "both") dirtyLayers.overlay = true;
    if (frameId !== null || isDisposed) return;
    frameId = window.requestAnimationFrame(flush);
  };

  const dispose = () => {
    isDisposed = true;
    if (frameId !== null) window.cancelAnimationFrame(frameId);
    frameId = null;
  };

  return { dispose, request };
};
